import './i18n/i18n'
import '@definitions/styles/global.css'
import { StyleConfigProvider } from 'common-components'
import { AuthConsumer, AuthProvider } from '@components'
import { AppRouter } from '@navigation/app-router'

function App() {
  return (
    <StyleConfigProvider>
      <div className='App'>
        <AuthProvider>
          <AuthConsumer>
            <AppRouter />
          </AuthConsumer>
        </AuthProvider>
      </div>
    </StyleConfigProvider>
  )
}

export default App
